import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

type FieldType = QuestionnaireApiModels.FieldTemplate['type'];
const DONT_NEED_REF_FIELD_TYPES: FieldType[] = [
  'add-exemptions',
  'address-international',
  'address-us',
  'break',
  'court-division-select',
  'creditor-select',
  'currency',
  'date',
  'explanation',
  'list',
  'long-text',
  'median-income',
  'monthly-income',
  'multi-select',
  'name',
  'number',
  // 'numeric',
  'percent',
  'phone-number',
  'selection',
  // 'short-text',
  'single-select',
  // 'ssn',
  'table',
] as const;

const componentNeedsRef = (type: FieldType): boolean => !DONT_NEED_REF_FIELD_TYPES.includes(type);

export default componentNeedsRef;